import { Injectable } from '@angular/core';
import { CanActivate, RedirectCommand, Router, UrlTree } from '@angular/router';
import { hasPasswordResetSession } from './nhost';

@Injectable({ providedIn: 'root' })
export class PasswordResetGuard implements CanActivate {
  constructor(private readonly router: Router) {}

  canActivate(): boolean | UrlTree | RedirectCommand {
    if (hasPasswordResetSession()) return true;

    return new RedirectCommand(
      this.router.createUrlTree(['/login'], {
        queryParams: { error: 'invalid-ticket' },
      }),
      { replaceUrl: true }
    );
  }
}
